import { z } from "zod";

export const FilterByNumberPayloadSchema = z.object({
  type: z.literal("filter_by_number"),
  query: z.number(),
  mode: z.union([z.literal("less_than"), z.literal("more_than"), z.literal("equals"), z.literal("not_equals")]),
});

export type FilterByNumberPayload = z.infer<typeof FilterByNumberPayloadSchema>;
export type FilterByNumberMode = FilterByNumberPayload["mode"];

export const filterByNumber = (payload: FilterByNumberPayload, number: number | null | undefined): boolean => {
  if (number === null || number === undefined) {
    if (payload.mode === "not_equals") {
      return true;
    }
    return false;
  }

  if (payload.mode === "less_than") {
    return number < payload.query;
  }

  if (payload.mode === "more_than") {
    return number > payload.query;
  }

  if (payload.mode === "equals") {
    return number === payload.query;
  }

  if (payload.mode === "not_equals") {
    return number !== payload.query;
  }

  // fall through; shouldn't happen
  return true;
};

export const filterByNumberWithUnknownPayload = (payload: unknown, number: number | null | undefined): boolean => {
  const safePayload = FilterByNumberPayloadSchema.safeParse(payload);

  if (!safePayload.success) {
    return true; // if we cannot apply the filter then don't filter at all
  }

  return filterByNumber(safePayload.data, number);
};

export const displayTextForFilterMode = (mode: FilterByNumberMode) => {
  switch (mode) {
    case "less_than":
      return "kleiner als";
    case "more_than":
      return "größer als";
    case "equals":
      return "gleich";
    case "not_equals":
      return "ungleich";
  }
};
